import React from "react";
import heart from "../ulits/images/heart.svg";
import locationicon from "../ulits/images/location_icon.svg";
import { configs } from "../config";
import { Link } from "react-router";
import { useState } from "react";
import { useEffect } from "react";

function Footer(props) {
  const [config, setConfig] = useState({});

  useEffect(() => {
    setConfig(props?.configData);
  }, [props?.configData]);

  const year = new Date().getFullYear();

  return (
    <div className="site-footer">
      <div className="footer-top">
        {config && Object.keys(config).length > 0 && (
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-12">
                <div className="footer-logo">
                  <Link>
                    <img
                      src={
                        config &&
                        config.footer_Logo &&
                        `${configs.localApiUrl}${config?.footer_Logo}`
                      }
                      onClick={() => window.scrollTo(0, 0)}
                      alt="footer-logo"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-6 col-xs-6 col-12">
                <ul className="list-unstyled contents">
                  <li>
                    <p>
                      <img src={locationicon} alt="location-icon" />
                      {config && config?.Address_Line_1}
                    </p>
                  </li>
                </ul>
              </div>
              {/* <div className="col-lg-2 col-md-6 col-sm-6 col-xs-6 col-12">
                <ul className="list-unstyled contents">
                  <li>
                    <Link>
                      <img src={locationicon} alt="location-icon" />
                      {config && config?.Address_Line_2}
                    </Link>
                  </li>
                </ul>
              </div> */}
              {/* <div className="col-lg-2 col-md-6 col-sm-6 col-xs-6 col-12">
                <ul className="list-unstyled contents">
                  <li>
                    <Link>
                      <img src={locationicon} alt="location-icon" />
                      {config && config?.Address_Line_3}
                    </Link>
                  </li>
                </ul>
              </div> */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-12">
                <ul className="list-unstyled">
                  <li>
                    <Link to={`tel:${config && config.Free_phone}`}>
                      Free Phone: {config && config?.Free_phone}
                    </Link>
                  </li>
                  <li>
                    <Link to={`tel:${config && config.Landline}`}>
                      Landline: {config && config?.Landline}
                    </Link>
                  </li>
                  <li>
                    <Link to={`tel:${config && config.Contact_Number}`}>
                      Mobile: {config && config?.Contact_Number}
                    </Link>
                  </li>
                  <li>
                    <Link to={`mailto:${config && config.Support_Email}`}>
                      Email: {config && config?.Support_Email}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <ul className="list-inline">
                <li>
                  <Link to="/terms">Terms of use</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy</Link>
                </li>
              </ul>
              <p>
                &copy; {year} Copyright We Buy Any Spanish Left Hand Drive Cars.com
                Limited. All Rights Reserved.
              </p>
              <div className="loyalty-text">
                made with
                <em>
                  <img src={heart} alt="heart" />
                </em>
                by
                <a href="https://softorigin.co.uk/" target="_blank">
                  {" "}
                  Soft Origin
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
